import { Injectable } from '@angular/core';
import { RCSSuggestionStats } from '../models/rcs-suggestion-stats.model';

@Injectable({ providedIn: 'root' })
export class RCSSuggestionStatsAdapter {
  adapt(item: any): RCSSuggestionStats {
    const suggestionStats = new RCSSuggestionStats();
    suggestionStats.suggestionID = item.SuggestionID ?? item.suggestionID;
    suggestionStats.displayText = item.DisplayText ?? item.displayText;
    suggestionStats.suggestionType = item.SuggestionType ?? item.suggestionType;
    suggestionStats.suggestionScope = item.SuggestionScope ?? item.suggestionScope;
    suggestionStats.cardIndex = item.CardIndex ?? item.cardIndex;
    suggestionStats.clickCount = item.ClickCount ?? item.clickCount ?? 0;
    suggestionStats.sentCount = item.SentCount ?? item.sentCount ?? 0;
    suggestionStats.totalClicks = item.TotalClicks ?? item.totalClicks ?? 0;
    return suggestionStats;
  }
}
